import {
  POBillToContactModes,
  type POBillToContactModeEnum,
} from '@webapp/platform/iam/entities/enums/POBillToContactModeEnum'
import { type POBillToContactSystemPreference } from '@webapp/platform/iam/entities/SystemPreference'
import { type POBillToContactApiModel } from '../api-models/POBillToContactApiModel'

const CONTACT_MODES: readonly POBillToContactModeEnum[] =
  Object.values(POBillToContactModes)

const toContactMode = (mode: number): POBillToContactModeEnum =>
  CONTACT_MODES.find((m) => m === mode) ?? POBillToContactModes.PURCHASER

export const mapPOBillToContactApiModel = (
  apiModel: POBillToContactApiModel
): POBillToContactSystemPreference['value'] => ({
  mode: toContactMode(apiModel.mode),
  userId: apiModel.user_id,
})

export const mapPOBillToContactToApiModel = (
  contact: POBillToContactSystemPreference['value']
): POBillToContactApiModel => ({
  mode: contact.mode,
  user_id: contact.userId,
})
